import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const inputNoWhitespaceValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }

  const isWhitespace = (control.value || '').trim().length === 0;
  return isWhitespace ? { whitespace: true } : null;
};
